<template>
  <el-dialog
    width="720px"
    append-to-body
    :visible.sync="visible"
    :show-close="false"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    custom-class="safe-tips__dialog">
    <div class="safe-tips__dialog__header">
      <h3>{{title}}</h3>
    </div>
    <div class="safe-tips__dialog__body">
      <div v-html="content"></div>
    </div>
    <div class="safe-tips__dialog__footer el-dialog__footer">
      <kye-button type="primary" @click="iKnow">知道了</kye-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: 'safe-tips',
    data () {
      return {
        visible: false,
        title: window.__ERPGLOABLECONFIG__.SAFE_TIPS_TITLE,
        content: `<p>信息安全是公司不容侵犯的底线，勿使用不齿手段非法窃取，否则跨越将追究其民事及刑事责任，移交司法机关，使其得到法律的严惩！</p><br/>
      <p>1、机密信息包含客户信息、业务报价、客户合约、内部培训资料、系统源码等</p>
      <p>2、勿截图或下载公司机密信息发给外部人员</p>
      <p>3、若发现有内部人员泄露机密信息可举报到“总裁信箱”，核实属实将给予奖励！</p><br/>
      <p>注：现公司已启用全方位视频监控系统、文件加密系统、用户行为监控系统等多重保护，任何妄图窃取公司商业信息或内部机密的行为都将无所遁形！</p><br/>
      <p style="color:red;">忠告各位同仁：切莫自毁前程、以身试法！</p>`
      }
    },
    mounted () {
      this.$bus.$once('APP_LOADED', this.getSafeTips)
    },
    methods: {
      async getSafeTips () {
        let res = await this.$http('syslog.informationSecurityWarning.search', null, { cancel: true, axios: { headers: { 'X-menu-id': '2820215716730110' } } })
        if (res === false) {
          this.visible = true
          this.openTime = Date.now()
        } else {
          this.$bus.$emit('GLOBAL_DIALOG_NEXT:scheduling')
        }
      },
      iKnow () {
        this.visible = false
        let params = {
          openTime: this.openTime,
          closeTime: Date.now()
        }
        this.$http('syslog.informationSecurityWarning.save', params, false)
        this.$bus.$emit('GLOBAL_DIALOG_NEXT:scheduling')
      }
    }
  }
</script>

<style lang="scss">
  .safe-tips__dialog {
    &.el-dialog {
      background: rgba(0, 0, 0, 0);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0);
    }
    .el-dialog__header {
      display: none;
    }
    .el-dialog__body {
      padding: 0;
    }
    &__header {
      height: 164px;
      background-image: url('../../shared/assets/images/safe-tip-bg.png');
      position: relative;
      h3 {
        position: absolute;
        top: 136px;
        left: 20px;
        color: #fff;
        font-size: 20px;
        font-weight: bold;
        letter-spacing: 4px;
      }
    }
    &__body {
      padding: 12px 16px;
      background-color: #fff;
      // border-radius: 0 0 2px 2px;
      overflow-y: auto;
      max-height: calc(70vh - 280px);
      line-height: 1.5;
    }
    &__footer {
      // text-align: center;
      background-color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// src/layout/components/safe-tips.vue